import { render } from "./Colunista.vue?vue&type=template&id=5f3d8f6c&scoped=true"
import script from "./Colunista.vue?vue&type=script&lang=js"
export * from "./Colunista.vue?vue&type=script&lang=js"

import "./Colunista.vue?vue&type=style&index=0&id=5f3d8f6c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3d8f6c"]])

export default __exports__